import { Dropdown, useDayPicker } from 'react-day-picker';
import Select from '../../../inputs/Select';
import styles from './calendarDropdown.module.scss';
import { ArrowLeft, ArrowRight } from '../../../../icons';

const shortMonthMap: Record<string, string> = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'Jun',
  July: 'Jul',
  August: 'Aug',
  September: 'Sep',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec'
};

const getShortMonthLabel = (label: string) => {
  return shortMonthMap[label] || label;
};

const isMonthDropdown = (options: { label: string; value: number }[]) => {
  return options.some((option) => option.label === 'January');
};

export default function CalendarDropdown(
  props: React.ComponentPropsWithoutRef<typeof Dropdown>
) {
  const { previousMonth, nextMonth, goToMonth } = useDayPicker();
  const isMonthDropdownType = isMonthDropdown(props.options || []);
  return (
    <div className={styles.calendarDropdown}>
      {isMonthDropdownType && (
        <button
          className={styles.navButton}
          disabled={!previousMonth}
          aria-label="Previous month"
          onClick={() => {
            if (!previousMonth) return;
            goToMonth(previousMonth as Date);
          }}
        >
          <ArrowLeft />
        </button>
      )}
      <Select
        options={(props.options || []).map((option) => ({
          label: getShortMonthLabel(option.label),
          value: String(option.value),
          disabled: option.disabled
        }))}
        value={String(props.value)}
        onValueChange={(value) =>
          props.onChange?.({
            target: { value }
          } as React.ChangeEvent<HTMLSelectElement>)
        }
      />
      {!isMonthDropdownType && (
        <button
          className={styles.navButton}
          disabled={!nextMonth}
          aria-label="Next month"
          onClick={() => {
            if (!nextMonth) return;
            goToMonth(nextMonth as Date);
          }}
        >
          <ArrowRight />
        </button>
      )}
    </div>
  );
}
